import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { Observable } from 'rxjs'

import { environment } from '../../../environments/environment'

import { ApiOrder } from '../../cart/models/cart-models'

import * as moment from 'moment'
import { applyTranslations } from '../../core/helpers/translations';

const orderUrl = '/orders'

@Injectable()
export class CheckoutService {
    constructor(private http: HttpClient)
    { }

    public setOrderDetails(order: ApiOrder): Observable<ApiOrder> {
        return this.http.put<ApiOrder>(
            `${environment.baseApiUrl}${orderUrl}/${order._id}`,
            <ApiOrder>{
                dlvDate: moment(order.dlvDate, 'DD-MM-YYYY').toISOString(),
                dlvAddress: order.dlvAddress,
                comments: order.comments,
                customerReference: order.customerReference
            }
        ).pipe(map(order => {
            order.lines = order.lines.map(line => {
                line.product = applyTranslations([line.product])[0]
                return line
            })
            return order
        }))
    }

    public submitOrder(order: ApiOrder): Observable<ApiOrder> {
        return this.http.put<ApiOrder>(
            `${environment.baseApiUrl}${orderUrl}/${order._id}/checkout`,
            <ApiOrder>{
              dlvDate: moment(order.dlvDate, 'DD-MM-YYYY').toISOString(),
              dlvAddress: order.dlvAddress,
              comments: order.comments,
              customerReference: order.customerReference
            }
        )
    }
}
